// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"d5228d5a","453":"d02b2086","511":"12e757eb","638":"9884515a","989":"763d277a"}[chunkId] + ".chunk.js";
};